import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SharedService {
	private subject = new Subject<any>();

	sendMessage(message: string, payload?: any) {
		this.subject.next({ text: message, payload: payload });
	}

	getMessage(): Observable<any> {
		return this.subject.asObservable();
	}
}
